import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { AgGridLoadingOverlayComponent } from '../../Common/AgGrid/agGridLoadingOverlay.component';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { DataHubLogService } from './dataHubLog.service';
import { DataHubLogRepository } from './dataHubLog.repository';
import { DataHubLogListComponent } from './Data-Hub-Log-List/dataHubLogList.component';
import { DataHubLogListGridActionCellRendererComponent } from './Data-Hub-Log-List/agGridActionCellRenderer.component';
import { DataHubLogDetailsModalComponent } from './Data-Hub-Log-Details/dataHubLogDetailsModal.component';
import { DataHubLogDetailsGridComponent } from './Data-Hub-Log-Details/dataHubLogDetailsGrid.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule
    ],
    declarations: [
        DataHubLogListComponent,
        DataHubLogListGridActionCellRendererComponent,
        DataHubLogDetailsModalComponent,
        DataHubLogDetailsGridComponent
    ],
    providers: [
        DataHubLogService,
        DataHubLogRepository
    ],
    exports: []
})
export class DataHubLogModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('dataHubLogList', DataHubLogListComponent);
        hybridAdapterUtility.downgradeNg2Component('dataHubLogDetails', DataHubLogDetailsModalComponent);
        hybridAdapterUtility.downgradeNg2Component('dataHubLogDetailsGrid', DataHubLogDetailsGridComponent);
    }
}
